import { usePresentationDetail, useUpdateContext } from "../../../lib/presentationQueries";
import { useAutosaveEntity } from "../../../hooks/useAutosaveEntity";
import AutosaveField from "./AutosaveField";
import AutosaveStatus from "./AutosaveStatus";
import ConflictBanner from "./ConflictBanner";

export default function GoalAudienceArea({ workspaceId, presId }) {
  const { data } = usePresentationDetail(workspaceId, presId);
  const updateContext = useUpdateContext(workspaceId, presId);
  const ctx = data?.context;
  const auto = useAutosaveEntity({
    initialValues: {
      goal_text: ctx?.goal_text || "", audience_text: ctx?.audience_text || "",
      occasion_text: ctx?.occasion_text || "", notes_text: ctx?.notes_text || "",
    },
    revision: ctx?.revision,
    onSave: (payload) => updateContext.mutateAsync(payload),
  });

  if (!ctx) return null;

  return (
    <div className="max-w-2xl" data-testid="presentation-goal-audience-area">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif text-xl text-ink">Goal &amp; Audience</h2>
        <AutosaveStatus status={auto.status} onRetry={auto.retry} testId="presentation-context-autosave-status" />
      </div>
      <ConflictBanner conflict={auto.conflict} onKeepMine={auto.keepMineAfterConflict} onUseServer={auto.useServerAfterConflict} />
      <AutosaveField
        label="What's the goal of this presentation?" value={auto.values.goal_text}
        onChange={(v) => auto.setField("goal_text", v)} multiline testId="presentation-context-goal"
      />
      <AutosaveField
        label="Who's the audience?" value={auto.values.audience_text}
        onChange={(v) => auto.setField("audience_text", v)} multiline testId="presentation-context-audience"
      />
      <AutosaveField
        label="Occasion" value={auto.values.occasion_text}
        onChange={(v) => auto.setField("occasion_text", v)} testId="presentation-context-occasion"
      />
      <AutosaveField
        label="Notes" value={auto.values.notes_text}
        onChange={(v) => auto.setField("notes_text", v)} multiline testId="presentation-context-notes"
      />
    </div>
  );
}
